import React, { Component } from 'react'

import StudentList from './components/StudentList/StudentList'
import ArchiveClass from './components/ArchiveClass/ArchiveClass'
import ModalContext from 'components/Context/ModalContext'
import Button from 'components/UI/Button/Button'
import Loader from 'components/UI/Loader/Loader'
import PropTypes from 'prop-types'
import {
  Content,
  Header,
  LargeTitle,
  SmallTitle,
  InfoText,
  ClassControlsButton
} from './YourClass.styles'
import {
  phoneMaxWidth,
  LoaderWrapper,
  GradientWrapper
} from '../../DashboardSettings.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'
// import GoogleClassroomSyncModal from './components/GoogleClassroomSyncModal/GoogleClassroomSyncModalContainer'
// import GoogleClassroomUsersSyncModal from './components/GoogleClassroomUsersSyncModal/GoogleClassroomUsersSyncModalContainer'
// import GoogleResyncModal from './components/GoogleResyncModal/GoogleResyncModalContainer'
import Link from 'components/UI/Link'

export default class YourClass extends Component {
  // prevent update after failed mutation (due to wrong password)
  shouldComponentUpdate (nextProps) {
    const currentModalId = this.props.modal.getCurrent().id
    if (currentModalId === 'sensitiveInfoPopup' && this.props.students) {
      return false
    }
    return true
  }

  static propTypes = {
    groupId: PropTypes.string,
    courseId: PropTypes.string,
    modal: PropTypes.shape({
      closeAll: PropTypes.func,
      open: PropTypes.func,
      getCurrent: PropTypes.func
    }),
    syncAccountWithGoogle: PropTypes.func,
    loading: PropTypes.bool,
    screenWidth: PropTypes.string,
    client: PropTypes.any,
    queries: PropTypes.array,
    loggedInUser: PropTypes.shape({
      isGoogle: PropTypes.bool,
      googleEmail: PropTypes.string,
      hasRefreshToken: PropTypes.bool
    }),
    isParent: PropTypes.bool,
    students: PropTypes.array,
    yearGroup: PropTypes.string,
    updateStudentDetails: PropTypes.func,
    addStudents: PropTypes.func,
    deleteStudent: PropTypes.func,
    hasRefreshToken: PropTypes.bool,
    archivedGroups: PropTypes.array,
    registerGroup: PropTypes.func,
    changeActiveGroup: PropTypes.func,
    isGoogleGroup: PropTypes.bool,
    groupName: PropTypes.string
  }

  static defaultProps = {
    modal: {},
    client: {},
    loggedInUser: {},
    archivedGroups: [],
    students: [],
    queries: []
  }

  componentDidMount () {}

  syncGoogleClass () {
    this.props.modal.closeAll()
    // this.props.modal.open(
    //   <GoogleClassroomSyncModal
    //     groupId={this.props.groupId}
    //     onExit={() => this.props.modal.closeAll()}
    //     onSuccess={courseId => {
    //       this.syncGoogleStudents(courseId)
    //     }}
    //   />
    // )
  }

  syncGoogleStudents (courseId) {
    this.props.modal.closeAll()
    // this.props.modal.open(
    //   <GoogleClassroomUsersSyncModal
    //     courseId={this.props.courseId || courseId}
    //     onChangeGoogleGroup={() => {
    //       this.props.modal.closeAll()
    //       this.syncGoogleClass()
    //     }}
    //     onExit={() => this.props.modal.closeAll()}
    //   />
    // )
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    if (nextProps.courseId) {
      // this.syncGoogleStudents(nextProps.courseId)
    }
  }

  async onGoogleAccountSyncSuccess (googleRes) {
    await this.props.syncAccountWithGoogle(googleRes.code)
  }

  render () {
    const {
      loading,
      screenWidth,
      client,
      queries,
      modal,
      loggedInUser,
      isParent,
      students,
      yearGroup,
      updateStudentDetails,
      addStudents,
      deleteStudent
    } = this.props

    if (loading) {
      return (
        <LoaderWrapper>
          <Loader
            bgColor='rgba(0,0,0,0)'
            itemColor={colors.pink}
            itemSize='90'
          />
        </LoaderWrapper>
      )
    }

    // if (loggedInUser.isGoogle && !loggedInUser.hasRefreshToken) {
    //   this.props.modal.open(
    //     <GoogleResyncModal
    //       googleEmail={this.props.loggedInUser.googleEmail}
    //       onExit={() => this.props.modal.closeAll()}
    //       onSuccess={() => this.props.modal.closeAll()}
    //     />
    //   )
    // }

    return (
      <GradientWrapper>
        <Content isParent={isParent}>
          {screenWidth > phoneMaxWidth && (
            <Header>
              <LargeTitle>{this.props.groupName}</LargeTitle>
              <SmallTitle>
                {`Add your ${isParent ? 'children' : 'students'}`}
              </SmallTitle>
            </Header>
          )}
          <ClassControlsButton>
            <Link to='/dashboard/control-center'>
              <Button bgColor={colors.pink}>Class controls</Button>
            </Link>
            <div>(Limit your students access to features by blocking them here)</div>
          </ClassControlsButton>
          <StudentList
            client={client}
            queries={queries}
            modal={modal}
            screenWidth={screenWidth}
            loggedInUser={loggedInUser}
            isParent={isParent}
            students={students}
            yearGroup={yearGroup}
            updateStudentDetails={updateStudentDetails}
            addStudents={addStudents}
            deleteStudent={deleteStudent}
            isGoogleGroup={this.props.isGoogleGroup}
            onGoogleSyncSuccess={this.onGoogleAccountSyncSuccess.bind(this)}
            syncGoogleClass={this.syncGoogleClass.bind(this)}
            syncGoogleStudents={this.syncGoogleStudents.bind(this)}
          />
          {screenWidth > phoneMaxWidth &&
            !isParent && (
            <InfoText>
                Add a parent email next to each child so that they can receive
                regular updates on the work your children are doing at school on
                Night Zookeeper.
            </InfoText>
          )}
          {screenWidth > phoneMaxWidth && (
            <ModalContext.Consumer>
              {modal => (
                <ArchiveClass
                  modal={modal}
                  teacher={this.props.loggedInUser}
                  archivedClasses={this.props.archivedGroups}
                  createNewGroup={this.props.registerGroup}
                  changeActiveGroup={this.props.changeActiveGroup}
                />
              )}
            </ModalContext.Consumer>
          )}
        </Content>
      </GradientWrapper>
    )
  }
}
